import { render, staticRenderFns } from "./m_skilllist.vue?vue&type=template&id=1af6068a&scoped=true&"
import script from "./m_skilllist.vue?vue&type=script&lang=js&"
export * from "./m_skilllist.vue?vue&type=script&lang=js&"
import style0 from "./m_skilllist.vue?vue&type=style&index=0&id=1af6068a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af6068a",
  null
  
)

export default component.exports